module.exports = __webpack_public_path__ + "6afc0d5075bc83b6f2f511cdd0cbbe83.pdf";